import { useExperiment } from "../../hooks/experiments";
import type { ShowcaseProps } from "../../pages/ShowcasePage/types";
import { Showcase as ShowcaseControl } from "./Showcase";
import { ShowcaseTreatmentEmbeddedQuickReplies } from "./ShowcaseTreatmentEmbeddedQuickReplies";

export { ShowcaseProductsList } from "./ShowcaseProductsList";
export type { ShowcaseProductsListProps } from "./ShowcaseProductsList";
export { ShowcaseExploreOptions } from "./ShowcaseExploreOptions";
export type { ShowcaseExploreOptionsProps } from "./ShowcaseExploreOptions";
export { ShowcaseEmbeddedQuickReplies } from "./ShowcaseEmbeddedQuickReplies";

export const Showcase = (props: ShowcaseProps) => {
  const quickRepliesExperiment = useExperiment(
    "us2511QuickRepliesOnSingleShowcase",
  );
  const insuranceAdvisorExperiment = useExperiment(
    "us2506BrieTheBotLiveTradesImpactAnalysis",
  );
  const isTreatment =
    quickRepliesExperiment === "treatment" &&
    insuranceAdvisorExperiment === "treatment";
  if (isTreatment) {
    return <ShowcaseTreatmentEmbeddedQuickReplies {...props} />;
  } else {
    return <ShowcaseControl {...props} />;
  }
};
